module.exports = __webpack_public_path__ + "static/media/allMajorCreditCards.5ab6fdf2.png";